// Voir / masquer le mot de passe.
// Chaque conteneur `.see-password` a son champ (`.see-password-input`) et deux
// icônes Lucide (œil ouvert + œil barré, l'une masquée par `.d-none`). Un clic
// sur l'une bascule les deux icônes et le type du champ.
// Délégation sur `document` → robuste à la navigation Turbo, sans double-binding.
document.addEventListener("click", (event) => {
  const icon = event.target.closest(".see-password .o-ico")
  if (!icon) return

  const container = icon.closest(".see-password")
  const input = container.querySelector(".see-password-input")
  if (!input) return

  container.querySelectorAll(".o-ico").forEach((i) => i.classList.toggle("d-none"))
  input.setAttribute("type", input.getAttribute("type") === "password" ? "text" : "password")
})
